<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      temporary
      fixed
      :color="generalSetting.leftSideNav.attr.color"
    >
      <div class="d-flex justify-space-between align-center pa-3">
        <span style="font-weight: 600; font-size: 16px;">{{ $t('nav.menu') }}</span>
        <v-btn icon @click="drawer = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-divider />
      <v-list nav dense>
        <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item @click="drawer = false; $router.push('/')">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t('nav.home') }}</v-list-item-title>
          </v-list-item>

          <v-list-item @click="drawer = false; $router.push('/menu')">
            <v-list-item-icon>
              <v-icon>mdi-text-box</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t('nav.menu') }}</v-list-item-title>
          </v-list-item>

          <v-list-item @click="drawer = false; $router.push('/my-order')">
            <v-list-item-icon>
              <v-icon>mdi-text-box-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t('nav.myOrder') }}</v-list-item-title>
          </v-list-item>

        </v-list-item-group>

        <v-list-item @click="allergenDialog = true; drawer = false">
          <v-list-item-icon>
            <v-icon>mdi-leaf</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('nav.allergens') }}</v-list-item-title>
        </v-list-item>

        <img
          v-if="generalSetting.appLogo.attr.src"
          :src="generalSetting.appLogo.attr.src"
          :width="generalSetting.appLogo.attr.width"
          :height="generalSetting.appLogo.attr.height"
          :style="logoStyle"
          max-height="100px"
          min-height="100px"
        />
      </v-list>
    </v-navigation-drawer>

    <v-dialog v-model="allergenDialog" fullscreen transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar :color="value.attr.style.backgroundColor || '#323232'" dark>
          <v-btn icon dark @click="allergenDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title :style="{ color: value.attr.style.color || '#ffffff' }">
            {{ $t('nav.allergens') }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-row>
            <v-col
              v-for="allergen in allergens"
              :key="allergen.code"
              cols="6"
            >
              <div class="d-flex align-center pa-2">
                <img
                  :src="`/asset/allergen/1/${allergen.code}.png`"
                  width="40"
                  height="40"
                  class="mr-3"
                />
                <span style="font-size: 16px;">{{ allergen.name }}</span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-app-bar app v-bind="value.attr">
      <v-btn
        v-if="showBackButton"
        icon
        @click="$store.getters['session/getIsExpired'] ? $router.push('/') : $router.push('/menu')"
        :style="{ color: value.attr.style.color }"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-app-bar-nav-icon
        v-else-if="generalSetting.leftSideNav && generalSetting.leftSideNav.active"
        @click="handleDrawer"
        :style="{ color: value.attr.style.color }"
      ></v-app-bar-nav-icon>
      <v-toolbar-title
        :style="{
          color: value.attr.style.color,
          fontSize: value.attr.style.fontSize,
        }"
        >{{ $lt(value.text) }}</v-toolbar-title
      >
      <v-spacer />
      <template v-if="generalSetting.appSetting.translation">
        <v-menu offset-y :style="{ color: value.attr.style.color }" rounded
          :content-class="'language-menu'">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :style="{ color: value.attr.style.color }"
              dark
              v-bind="attrs"
              v-on="on"
              text
            >
              {{ selectedLang }}
            </v-btn>
          </template>
          <v-list dark dense>
            <v-list-item v-for="(item, index) in items" :key="index" @click="$i18n.locale = item.key">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-if="generalSetting.appSetting.accountLogin">
        <v-btn text :style="{ color: value.attr.style.color }">Log in</v-btn>
      </template>
      <!-- <v-badge
        color="warning"
        :content="`${totalProduct}`"
        overlap
        offset-x="20"
        offset-y="20"
      >
        <v-btn
          :loading="isLoading"
          icon
          :style="{ color: value.attr.style.color }"
          @click="goToCart"
          depressed
        >
          <v-icon>mdi-cart</v-icon>
        </v-btn>
      </v-badge> -->
    </v-app-bar>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

// What the switcher offered before the locale list existed on the setting
// endpoint. Used when the backend does not send one, which includes a session
// restored from a pre-locales build until the theme TTL lapses.
const FALLBACK_LOCALES = ['en', 'nl'];

export default {
  setup() {},
  props: {
    value: Object,
  },
  data() {
    return {
      isLoading: false,
      drawer: false,
      allergenDialog: false,
      group: null,
      innerValue: this.value,
      allergens: [
        { code: 'egg', name: 'Ei' },
        { code: 'gluten', name: 'Gluten' },
        { code: 'lupin', name: 'Lupine' },
        { code: 'milk', name: 'Melk' },
        { code: 'mustard', name: 'Mosterd' },
        { code: 'nuts', name: 'Noten' },
        { code: 'peanut', name: "Pinda's" },
        { code: 'celery', name: 'Selderij' },
        { code: 'crustaceans', name: 'Schaaldieren' },
        { code: 'sesame', name: 'Sesamzaad' },
        { code: 'soy', name: 'Soja' },
        { code: 'sulphite', name: 'Sulfiet' },
        { code: 'fish', name: 'Vis' },
        { code: 'molluscs', name: 'Weekdieren' },
      ],
    };
  },
  watch: {
    drawer(val) {
      this.$emit('drawerChanged', val);
    },
    value(newValue) {
      this.innerValue = newValue;
    },
    innerValue(newValue) {
      this.$emit("input", newValue);
    },
    /**
     * A tenant can switch off the locale the customer is currently reading --
     * mid-session, since the theme refetches on a TTL. Leaving $i18n.locale
     * pointing outside the rendered list strands them on a language the
     * switcher can no longer move them off, so move to the base locale, or to
     * whatever is first if base is not on offer.
     *
     * immediate, because the mismatch is already there on a cold load: the
     * locale is restored from localStorage before the theme arrives.
     */
    languageLocales: {
      immediate: true,
      handler(locales) {
        if (!locales.length || locales.includes(this.$i18n.locale)) {
          return;
        }
        const base = this.$store.getters['theme/baseLocale'];
        this.$i18n.locale = locales.includes(base) ? base : locales[0];
      },
    },
  },
  methods: {
    handleDrawer() {
      this.$emit("iconClicked", true);
      this.drawer = true;
    },
    goToCart() {
      if (!this.isCurrentLocation) {
        this.isLoading = true;
        window.setTimeout(() => {
          this.$router.push("/cart");
          this.isLoading = false;
        }, 1000);
      }
    },
  },
  computed: {
    /**
     * Only locales that are BOTH switched on for the tenant and backed by a
     * message file. The catalogue is translated per the setting endpoint, but
     * the UI chrome around it -- nav, order table, ADD button -- comes from
     * src/i18n, so offering a locale with no messages there renders translated
     * product names under English furniture. fr/es appear here on their own the
     * day their message files land; nothing else has to change.
     */
    languageLocales() {
      const withMessages = Object.keys(this.$i18n.messages);
      const active = this.$store.getters['theme/activeLocales'];
      const usable = active.filter((locale) => withMessages.includes(locale));
      // Empty means either no locale list at all, or a list naming only locales
      // this build cannot render. Both leave the switcher with nothing to show,
      // so fall back rather than render an empty menu.
      return usable.length ? usable : FALLBACK_LOCALES.filter((l) => withMessages.includes(l));
    },
    items() {
      return this.languageLocales.map((locale) => ({
        key: locale,
        title: locale.toUpperCase(),
      }));
    },
    showBackButton() {
      return ['/my-order', '/cart'].includes(this.$route.path);
    },
    ...mapGetters({
      generalSetting: "theme/general",
    }),
    ...mapState({
      cartProducts: (state) => state.cart.products,
    }),
    totalProduct() {
      return this.$store.getters['cart/getTotalProduct'];
    },
    logoStyle() {
      if (this.isIPHONE) {
        const nn =
          this.generalSetting.appLogo.attr.style.bottom.match(/[0-9]+/);
        const bottomPx = parseInt(nn[0]) + 120;
        return {
          position: "fixed",
          bottom: `${bottomPx}px`,
          left: this.generalSetting.appLogo.attr.style.left,
        };
      } else {
        return {
          position: "fixed",
          bottom: this.generalSetting.appLogo.attr.style.bottom,
          left: this.generalSetting.appLogo.attr.style.left,
        };
      }
    },
    isIPHONE() {
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },
    selectedLang() {
      return this.$i18n.locale.toUpperCase();
    },
    isCurrentLocation() {
      return window.location.pathname === "/cart";
    },
  },
};
</script>
<style scoped>
.language-menu {
  z-index: 999 !important;
  background-color: #404040 !important;
}
</style>
